import React, { useEffect, useState } from "react";
import LV_ART_Articulos_SelectorConGrid from "../Compuestos/Complejos/Articulos/LV_ART_Articulos_SelectorConGrid";
import LVSelectorOperacionesVenta from "../../Componentes/Selectores/LVSelectorOperacionesVenta";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";
import { DateBox, TextBox } from "devextreme-react";
import ComboAbmConMonedas from "../Compuestos/Combos/ComboAbmConMonedas";
import ComboAbmConCondicionesVenta from "../Compuestos/Combos/ComboAbmConCondicionesVenta";
import ComboVenListaPreciosCabecera from "../Compuestos/Combos/ComboVenListaPreciosCabecera";
import ComboAbmEexClientes from "../Compuestos/Combos/ComboAbmEexClientes";
import ComboVenDocsVentaTipos from "../Compuestos/Combos/ComboVenDocsVentaTipos";
import LVNumberBoxDocumento from "../Compuestos/Complejos/LVNumberBoxDocumento";
import ComboAbmZonUbicaciones from "../Compuestos/Combos/ComboAbmZonUbicaciones";
import LVSelectorPercepcionesVenta from "../Selectores/LVSelectorPercepcionesVenta";
import { useNavigate } from 'react-router-dom';
import { function_ABM_CON_Monedas_Leer } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_Monedas";

export const VEN_DocsVenta = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [idDocVentaAsignado, setIdDocVentaAsignado] = useState(0);
  const [idDocVentaReferente, setIdDocVentaReferente] = useState(0);

  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState(false);
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState(false);
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState(false);

  const [showPopupAdquirirClonar, setShowPopupAdquirirClonar] = useState(false);
  const [idTipoParaAdquirirClonar, setIdTipoParaAdquirirClonar] = useState(0);
  const [idOperacionParaAdquirirClonar, setIdOperacionParaAdquirirClonar] = useState(0);

  const [showPopupPercepciones, setShowPopupPercepciones] = useState(false);
  const [importeTotalPercepciones, setImporteTotalPercepciones] = useState(0);

  const [idCliente, setIdCliente] = useState(0);
  const [codigoListaPrecios, setCodigoListaPrecios] = useState("");
  const [idTipo, setIdTipo] = useState(4); //PREDEFINIDO PARA TODA LA PAGINA
  const [idTipoDocVenta, setIdTipoDocVenta] = useState(0);
  const [codigoMoneda, setCodigoMoneda] = useState("");
  const [cotizacion, setCotizacion] = useState(0);
  const [codigoMonedaReferente, setCodigoMonedaReferente] = useState("");
  const [codigoCondicionVenta, setCodigoCondicionVenta] = useState("");
  const [codigoUbicacionOrigen, setCodigoUbicacionOrigen] = useState("");
  const [fecha, setFecha] = useState(new Date());
  const [fechaVencimiento, setFechaVencimiento] = useState(new Date());

  const [datosDocumento, setDatosDocumento] = useState([]);
  const [datosConceptoObservaciones, setDatosConceptoObservaciones] = useState([]);
  const [datosDetalle, setDatosDetalle] = useState([]);
  const [datosImpuestos, setDatosImpuestos] = useState([]);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const [idItemMasAlto, setIdItemMasAlto] = useState(1);
  const [totalImporteDelComponenteSelectorArticulos, setTotalImporteDelComponenteSelectorArticulos] = useState(0);
  const [totalImporteNetoDelComponenteSelectorArticulos, setTotalImporteNetoDelComponenteSelectorArticulos] = useState(0);

  const { VEN_DocsVenta_Cabecera: { function_VEN_DocsVenta_Cabecera_Insertar,
    function_VEN_DocsVenta_Cabecera_Leer,
    function_VEN_DocsVenta_Cabecera_Modificar,
    function_VEN_DocsVenta_Generar_JSON } } = require('neftis7_apicaller');
  const { VEN_Pedidos_Cabecera: { function_VEN_Pedidos_Cabecera_Leer } } = require('neftis7_apicaller');
  const { INV_Remitos_Cabecera: { function_INV_Remitos_Cabecera_Leer } } = require('neftis7_apicaller');
  const { Varios: { ObtieneParametros,
    TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
  const { ABM_EEX_Clientes: { function_ABM_EEX_Clientes_Leer } } = require('neftis7_apicaller');
  const { ABM_IMP_PuntosFiscales: { function_ABM_IMP_PuntosFiscales_LeerPorTerminal } } = require('neftis7_apicaller');

  const handleOnValueChanged_Monedas = async (e) => {
    if (!e.value || e.value == "") {
      setCodigoMoneda("")
      setCotizacion(0)
    } else {
      setCodigoMoneda(e.value)
      const resultMoneda = await function_ABM_CON_Monedas_Leer(e.value) 
      if (resultMoneda && resultMoneda.data) {
        setCotizacion(resultMoneda.data[0].Cotizacion)
      }
    }
  };

  const handleOnValueChanged_Clientes = async (e) => {
    if (e.value < 1 || !e.value) {
      setIdCliente(0)
    } else {
      const resultCliente = await function_ABM_EEX_Clientes_Leer(e.value)
      if (resultCliente && resultCliente.data) {
        setIdCliente(e.value)

        if (resultCliente.data.IdTipoDocVentaDefault) {
          if (idTipoDocVenta < 1) {
            setIdTipoDocVenta(resultCliente.data.IdTipoDocVentaDefault);
            await handleOnValueChanged_TipoDocVenta({ value: resultCliente.data.IdTipoDocVentaDefault });
          }
        }

        if (resultCliente.data.CodigoListaPrecios && resultCliente.data.CodigoListaPrecios !== "") {
          if (codigoListaPrecios === "") {
            setCodigoListaPrecios(resultCliente.data.CodigoListaPrecios);
          } else {
            if (codigoListaPrecios != resultCliente.data.CodigoListaPrecios) {
              if (window.confirm("El Cliente tiene una Lista de Precios asignada, pero ya existe una seleccionada. ¿Desea reemplazarla por la asignada del Cliente?")) {
                setCodigoListaPrecios(resultCliente.data.CodigoListaPrecios);
              }
            }
          }
        }
      }
    }
  };

  const handleOnValueChanged_TipoDocVenta = async (e) => {
    if (e.value < 1) {
      setIdTipoDocVenta(0)
    } else {
      setIdTipoDocVenta(e.value)

      const Terminal = localStorage.getItem("Terminal")
      const resultPuntoFiscal = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(Terminal, idTipo, e.value)

      if (resultPuntoFiscal && resultPuntoFiscal.data && resultPuntoFiscal.data.length > 0) {
        setDatosDocumento({
          codigoPuntoVenta: parseInt(resultPuntoFiscal.data[0].CodigoPuntoFiscal),
          codigoPuntoVentaFormateado: resultPuntoFiscal.data[0].CodigoPuntoFiscal.toString().substring(0, 4).padStart(4, '0'),
        })

        if (resultPuntoFiscal.data[0].CodigoListaPrecios && resultPuntoFiscal.data[0].CodigoListaPrecios !== "") {
          if (codigoListaPrecios === "") {
            setCodigoListaPrecios(resultPuntoFiscal.data[0].CodigoListaPrecios);
          } else {
            if (codigoListaPrecios != resultPuntoFiscal.data[0].CodigoListaPrecios) {
              if (window.confirm("Ha cambiado el Tipo de Documento de Venta y este tiene una Lista de Precios diferente a la actual. ¿Desea reemplazarla?")) {
                setCodigoListaPrecios(resultPuntoFiscal.data[0].CodigoListaPrecios);
              }
            }
          }
        }
      } else {
        setDatosDocumento({
          codigoPuntoVenta: 0,
          codigoPuntoVentaFormateado: "0000"
        })
      }
    };
  }

  const handleOnTotalImporteDelComponenteChange_ = (newTotal, newNetoTotal) => {
    try {
      setTotalImporteDelComponenteSelectorArticulos(newTotal);
      setTotalImporteNetoDelComponenteSelectorArticulos(newNetoTotal)
    } catch (error) {
      alert(error)
    }
  };

  const handleOpen_AdquirirClonar = async (e) => {
    setShowPopupAdquirirClonar(true)
    setIdTipoParaAdquirirClonar(0)
    setIdOperacionParaAdquirirClonar(0)
  };

  const handleClose_AdquirirClonar = () => {
    setShowPopupAdquirirClonar(false)
    setIdTipoParaAdquirirClonar(0)
    setIdOperacionParaAdquirirClonar(0)
  };

  const handleConfirmAdquirirClonar = (idTipo, idOperacion) => {
    if (idTipo != 0 && idTipo != undefined && idOperacion != 0 && idOperacion != undefined) {
      setShowPopupAdquirirClonar(false)
      setIdTipoParaAdquirirClonar(idTipo)
      setIdOperacionParaAdquirirClonar(idOperacion)
    } else {
      setShowPopupAdquirirClonar(false)
      setIdTipoParaAdquirirClonar(0)
      setIdOperacionParaAdquirirClonar(0)
    }
  };

  const handleOnClick_Percepciones = (e) => {
    setShowPopupPercepciones(true)
  }

  const handleClose_Percepciones = () => {
    setShowPopupPercepciones(false)
  };

  const handleConfirmPercepciones = (dataImpuestos) => {
    if (dataImpuestos) {
      setShowPopupPercepciones(false)
      setDatosImpuestos(dataImpuestos)
    } else {
      setShowPopupPercepciones(false)
    }
  };

  const handleOnClick_Asiento = (e) => {

  }

  const handleOnClick_Costeo = (e) => {

  }

  const handleOnClick_Guardar = async (e) => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);
      
      const tiposDocSinIVA = [41, 42, 43, 71, 72, 73];

      // Validar si algún item tiene ImporteIVA > 0 y el idTipoDocVenta es uno de los prohibidos
      const tieneIVAInvalido = datosDetalle.some(item =>
        tiposDocSinIVA.includes(idTipoDocVenta) && (item.ImporteIVA > 0)
      );

      if (tieneIVAInvalido) {
        alert("No se puede continuar. Hay ítems con IVA mayor a 0 para un Documento Manual.");
        return;
      }

      const updatedDatosDetalle = datosDetalle.map(item => {
        // Si el campo CodigoUbicacion ya existe, cambia su valor al de la Terminal
        if (item.hasOwnProperty('CodigoUbicacion')) {
          item.CodigoUbicacion = codigoUbicacionOrigen;
        } else {
          // Si el campo CodigoUbicacion no existe, lo agrega con el valor de la Terminal
          item.CodigoUbicacion = codigoUbicacionOrigen;
        }

        item.CodigoUbicacionIngreso = codigoUbicacionOrigen;
        item.CodigoUbicacionEgreso = codigoUbicacionOrigen;
        return item;
      });
      setDatosDetalle(updatedDatosDetalle)

      const JSON = await function_VEN_DocsVenta_Generar_JSON(idDocVentaAsignado, 0, localStorage.getItem("IdPersona"),
        idTipoDocVenta, idCliente, FormateoFechaPara_yyyyMMdd_HHmmss(fecha), FormateoFechaPara_yyyyMMdd_HHmmss(fecha),
        FormateoFechaPara_yyyyMMdd_HHmmss(fechaVencimiento),
        datosDocumento.numeroFantasia, datosDocumento.codigoPuntoVenta, datosDocumento.numero,
        codigoMoneda, cotizacion, codigoMonedaReferente, 0, 0,
        datosConceptoObservaciones.concepto, datosConceptoObservaciones.observaciones, idDocVentaReferente,
        codigoCondicionVenta, 0, "", "", "", 0, 0, null, null,
        datosDetalle, datosImpuestos, [], [], [])

      if (props.Codigo.Codigo === "--NUEVO--") {

        const DocVentaCreado = await function_VEN_DocsVenta_Cabecera_Insertar(JSON, false)

        alert("Se ha generado el Documento de Venta ID: " + DocVentaCreado.data.codigoGenerado)
      } else {

        const DocVentaCreado = await function_VEN_DocsVenta_Cabecera_Modificar(JSON, false)

        alert("Se ha modificado el Documento de Venta ID: " + idDocVentaAsignado)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (localStorage.getItem("Terminal") > 0) {
          setIdTipoDocVenta(1)
          handleOnValueChanged_TipoDocVenta({ value: 1 })
        }

        const datosModificadores = await ObtieneParametros();
        setGlobalUsaArticulosConPresentacion(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion))
        setGlobalUsaArticulosConTamano(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano))
        setGlobalUsaArticulosConUnidadDeMedida(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida))
        setCodigoMoneda(datosModificadores.GlobalMonedaBase)
        setCodigoMonedaReferente(datosModificadores.GlobalMonedaReferente)

        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")
        } else {
          setTituloBoton("ACTUALIZAR ID " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR ID " + props.Codigo.Codigo)

          setIdDocVentaAsignado(props.Codigo.Codigo)

          const datosDocEditable = await function_VEN_DocsVenta_Cabecera_Leer(props.Codigo.Codigo)

          if (datosDocEditable.data.CAE) {
            alert("No se puede editar un Documento de Venta que se encuentra validado.")
            navigate("/VEN_DocsVenta_")
          }

          setIdTipoDocVenta(datosDocEditable.data.IdTipoDocVenta)
          setIdCliente(datosDocEditable.data.IdCliente)
          setCodigoMoneda(datosDocEditable.data.CodigoMoneda)
          setCotizacion(datosDocEditable.data.Cotizacion)
          setCodigoCondicionVenta(datosDocEditable.data.CodigoCondicionVenta)

          setFecha(new Date(datosDocEditable.data.Fecha))
          setCodigoMoneda(datosDocEditable.data.CodigoMoneda)
          setCodigoMonedaReferente(datosDocEditable.data.CodigoMonedaReferente)
          setCotizacion(datosDocEditable.data.Cotizacion)
          setCodigoUbicacionOrigen(datosDocEditable.data.CodigoUbicacionOrigen)

          setDatosConceptoObservaciones({
            concepto: datosDocEditable.data.Concepto,
            observaciones: datosDocEditable.data.Observaciones
          })

          if (datosDocEditable.data.Detalles && datosDocEditable.data.Detalles.length > 0) {
            const idMasAlto = datosDocEditable.data.Detalles.reduce((maxId, detalle) => {
              return detalle.IdItem > maxId ? detalle.IdItem : maxId;
            }, 0);

            const nuevosDatosDetalle = datosDocEditable.data.Detalles.map(detalle => {
              return {
                ...detalle,
                id: detalle.IdItem,
                ImporteBonificaciones: detalle.ImporteDescuentos,
                ImporteNetoTotal: detalle.ImporteNeto * detalle.Cantidad,
                ImporteDescuentosTotal: detalle.ImporteDescuentos * detalle.Cantidad,
                ImporteRecargosTotal: detalle.ImporteRacargos * detalle.Cantidad,
                ImporteIVATotal: detalle.ImporteIVA * detalle.Cantidad,
                ImporteImpuestosInternosTotal: detalle.ImporteImpuestosInternos * detalle.Cantidad
              };
            });

            setDatosDetalle(nuevosDatosDetalle);

            setIdItemMasAlto(idMasAlto + 1)
          }
        }

        setLoading(false);
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let datosDocClonable
        let IdDocVentaReferenteAdquirido = 0

        //DOCUMENTO VENTA
        if ([1, 2, 3, 11, 12, 13, 21, 22, 23, 31, 32, 33, 41, 42, 43, 51, 52, 53, 61, 62, 63, 71, 72, 73, 81, 82, 83, 91, 92, 93].includes(idTipoParaAdquirirClonar)) {
          datosDocClonable = await function_VEN_DocsVenta_Cabecera_Leer(idOperacionParaAdquirirClonar)

          if (datosDocClonable.data != undefined) {
            IdDocVentaReferenteAdquirido = datosDocClonable.data.idDocVentaReferente
          }
        }

        //PEDIDO
        if (idTipoParaAdquirirClonar === 101) {
          datosDocClonable = await function_VEN_Pedidos_Cabecera_Leer(idOperacionParaAdquirirClonar)

          datosDocClonable.data.Detalles = datosDocClonable.data.Detalles.map(detalle => ({
            ...detalle,
            IdItemPedido: detalle.IdItem
          }));
        }

        //COTIZACION
        if (idTipoParaAdquirirClonar === 102) {
          datosDocClonable = await function_VEN_Pedidos_Cabecera_Leer(idOperacionParaAdquirirClonar)

          datosDocClonable.data.Detalles = datosDocClonable.data.Detalles.map(detalle => ({
            ...detalle,
            IdItemCotizacion: detalle.IdItem
          }));
        }

        //REMITO
        if (idTipoParaAdquirirClonar === 301) {
          datosDocClonable = await function_INV_Remitos_Cabecera_Leer(idOperacionParaAdquirirClonar)

          datosDocClonable.data.Detalles = datosDocClonable.data.Detalles.map(detalle => ({
            ...detalle,
            IdItemRemito: detalle.IdItem
          }));
        }

        if (datosDocClonable && datosDocClonable.data) {
          setIdTipoDocVenta(datosDocClonable.data.IdTipoDocVenta)
          setIdCliente(datosDocClonable.data.IdCliente)
          setCodigoMoneda(datosDocClonable.data.CodigoMoneda)
          setCotizacion(datosDocClonable.data.Cotizacion)
          setCodigoCondicionVenta(datosDocClonable.data.CodigoCondicionVenta)
          setDatosConceptoObservaciones({
            concepto: datosDocClonable.data.Concepto,
            observaciones: datosDocClonable.data.Observaciones
          })

          if (datosDocClonable.data.Detalles && datosDocClonable.data.Detalles.length > 0) {
            const idMasAlto = datosDocClonable.data.Detalles.reduce((maxId, detalle) => {
              return detalle.IdItem > maxId ? detalle.IdItem : maxId;
            }, 0);

            const nuevosDatosDetalle = datosDocClonable.data.Detalles.map(detalle => {
              return {
                ...detalle,
                id: detalle.IdItem,
                ImporteBonificaciones: detalle.ImporteDescuentos,
                ImporteNetoTotal: detalle.ImporteNeto * detalle.Cantidad,
                ImporteDescuentosTotal: detalle.ImporteDescuentos * detalle.Cantidad,
                ImporteRecargosTotal: detalle.ImporteRacargos * detalle.Cantidad,
                ImporteIVATotal: detalle.ImporteIVA * detalle.Cantidad,
                ImporteImpuestosInternosTotal: detalle.ImporteImpuestosInternos * detalle.Cantidad
              };
            });

            setDatosDetalle(nuevosDatosDetalle);

            setIdItemMasAlto(idMasAlto + 1)
          }
        }

        setLoading(false);
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, [idTipoParaAdquirirClonar, idOperacionParaAdquirirClonar]);

  useEffect(() => {
    const total = datosImpuestos.reduce((acc, item) => acc + (item.Importe || 0), 0);
    setImporteTotalPercepciones(total);
  }, [datosImpuestos]);

  return (
    <>
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div>
          <div className="LV-GroupBox-div"
            style={{ marginLeft: '6px', marginRight: '6px', marginBottom: '7px', alignItems: 'center', justifyContent: 'center', gap: '30px' }}>
            <div className="LV-FlexContainer">
              <ComboAbmEexClientes onValueChanged={handleOnValueChanged_Clientes} value={idCliente} ancho="1020"  />
            </div>
            <div className="LV-FlexContainer"
              style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>

              <div style={{ marginLeft: '0px' }}>
                <ComboVenDocsVentaTipos onValueChanged={handleOnValueChanged_TipoDocVenta} value={idTipoDocVenta} ancho="310" />
              </div>

              <div style={{ display: 'flex', gap: '5px', alignItems: 'center', justifyContent: 'center', flexGrow: 1 }}>
                Fecha
                <DateBox displayFormat="dd/MM/yyyy" value={fecha} onValueChanged={(e) => setFecha(e.value)} width={120} />

                <div style={{ width: '20px' }}></div>

                <ComboAbmConCondicionesVenta onValueChanged={(e) => setCodigoCondicionVenta(e.value)} value={codigoCondicionVenta} />

                <div style={{ width: '20px' }}></div>

                Vencimiento
                <DateBox displayFormat="dd/MM/yyyy" value={fechaVencimiento} onValueChanged={(e) => setFechaVencimiento(e.value)} width={120} />

                <div style={{ width: '70px' }}></div>

                <LVNumberBoxDocumento
                  IdTipo={idTipo}
                  IdTipoMovimiento={idTipoDocVenta}
                  DatosDocumento={datosDocumento}
                  SetDatosDocumento={setDatosDocumento} />

                <div style={{ width: '70px' }}></div>

                <ComboAbmConMonedas onValueChanged={handleOnValueChanged_Monedas} value={codigoMoneda} />

                <div style={{ width: '70px' }}></div>

                <ComboAbmZonUbicaciones onValueChanged={(e) => setCodigoUbicacionOrigen(e.value)} value={codigoUbicacionOrigen} />
              </div>

              <div style={{ marginRight: '0px' }}>
                <ComboVenListaPreciosCabecera onValueChanged={(e) => setCodigoListaPrecios(e.value)} value={codigoListaPrecios} ancho="290" />
              </div>

            </div>
          </div>

          <LV_ART_Articulos_SelectorConGrid
            idEEX={idCliente}
            esCompras={false}
            esVentas={true}
            codigoListaPrecios={codigoListaPrecios}
            tieneEnCuentaLPdelCliente={true}
            codigoMonedaEnviadaPorDocumento={codigoMoneda}
            tienePresentaciones={globalUsaArticulosConPresentacion}
            tieneTamanos={globalUsaArticulosConTamano}
            tieneUnidadesMedida={globalUsaArticulosConUnidadDeMedida}
            DatosDetalle={datosDetalle}
            DatosConceptoObservaciones={datosConceptoObservaciones}
            setDatosDetalle={setDatosDetalle}
            setDatosConceptoObservaciones={setDatosConceptoObservaciones}
            IdItemMasAlto={idItemMasAlto}
            muestraComponentesDelTotal={true}
            onTotalImporteDelComponenteChange={handleOnTotalImporteDelComponenteChange_}
            Comprables={0}
            Vendibles={1}
            Fabricables={0}
            Stockeables={0}
            Servicios={0}
            ExcluirVendibles={0}
            ExcluirComprables={0}
            ExcluirFabricables={0}
            ExcluirStockeables={0}
            ExcluirServicios={0}
            PermiteVisualizarStock={true}
            PermiteVenderConPrecioCero={false}
            CodigoTipoDoc={idTipoDocVenta}
            pageSize={20} />

          <div style={{ display: 'flex', marginBottom: '5px', marginTop: '20px', alignItems: 'center', justifyContent: 'center', gap: '50px' }}>
            <LVButtonAccion Texto="ADQUIRIR / CLONAR" onClick={handleOpen_AdquirirClonar} />
            {showPopupAdquirirClonar ? (
              <>
                <LVSelectorOperacionesVenta
                  onConfirm={(idTipo, idOperacion) => handleConfirmAdquirirClonar(idTipo, idOperacion)}
                  onClose={handleClose_AdquirirClonar} />
              </>
            ) : null}

            <LVButtonAccion Texto={importeTotalPercepciones > 0 ? `PERCEPCIONES INCLUIDAS` : "PERCEPCIONES"}
              onClick={handleOnClick_Percepciones} />
            {showPopupPercepciones ? (
              <>
                <LVSelectorPercepcionesVenta
                  onConfirm={(datosImpuestos) => handleConfirmPercepciones(datosImpuestos)}
                  onClose={handleClose_Percepciones}
                  Percepciones={datosImpuestos}
                  ImporteTotal={totalImporteNetoDelComponenteSelectorArticulos}
                />
              </>
            ) : null}

            <LVButtonAccion Texto="ASIENTO" onClick={handleOnClick_Asiento} />

            <LVButtonAccion Texto="COSTEO" onClick={handleOnClick_Costeo} />

            <LVButtonAccion
              Disabled={cierreEnProceso} Texto={TituloBoton} onClick={handleOnClick_Guardar} />
          </div >
        </div >
      )}
    </>
  )
};